import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Notificações")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fa-2x fas fa-folder-open text-muted mb-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Você ainda não possui nenhuma notificação ", -1)
const _hoisted_7 = {
  key: 0,
  class: "fa-solid fa-circle ms-auto text-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loadingItems)
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!_ctx.items.length)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 0,
                  totalItemsRegistered: _ctx.totalItemsRegistered
                }, {
                  noItemsRegistered: _withCtx(() => [
                    _hoisted_5,
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["totalItemsRegistered"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["d-flex py-4", {
            'border-bottom': index !== _ctx.items.length - 1,
            'pt-2': index === 0,
          }])
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-subtitle mb-1", { 'text-muted': item.read }])
                  }, _toDisplayString(item.title), 3),
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-paragraph mb-1", { 'text-muted': item.read }])
                  }, _toDisplayString(item.description), 3),
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-label mb-0", { 'text-muted': item.read }])
                  }, _toDisplayString(item.formatted_date), 3)
                ]),
                (!item.read)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
    ])
  ]))
}